"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const pixi_js_1 = require("pixi.js");
const AceOfShadows_1 = __importDefault(require("./scenes/AceOfShadows"));
const VerbalMagic_1 = __importDefault(require("./scenes/VerbalMagic"));
const PhoenixFlame_1 = __importDefault(require("./scenes/PhoenixFlame"));
pixi_js_1.BaseTexture.defaultOptions.scaleMode = pixi_js_1.SCALE_MODES.NEAREST;
class Game {
    constructor() {
        this.currentScene = null;
        this.app = new pixi_js_1.Application({
            width: 720,
            height: 1280,
            autoDensity: true,
            resolution: 1,
            antialias: true,
            backgroundColor: 0x1099bb,
            // resolution: window.devicePixelRatio || 1,
        });
        document.body.appendChild(this.app.view);
        const style = new pixi_js_1.TextStyle({
            fontFamily: "\"Lucida Console\", Monaco, monospace",
            fontSize: 18
        });
        this.fpsText = new pixi_js_1.Text('', style);
        this.fpsText.position.set(10, 10);
        this.app.ticker.add((delta) => {
            this.updateFPS();
        });
        this.handleResize();
        window.addEventListener('resize', this.handleResize.bind(this));
    }
    updateFPS() {
        this.fpsText.text = `FPS: ${(this.app.ticker.FPS).toFixed(2)}`;
    }
    loadScene(index) {
        if (this.currentScene) {
            this.currentScene.destroy();
        }
        // Clear all children except the fpsText
        this.app.stage.removeChildren();
        this.app.stage.addChild(this.fpsText);
        const scenes = [
            AceOfShadows_1.default,
            VerbalMagic_1.default,
            PhoenixFlame_1.default
        ];
        if (index >= 0 && index < scenes.length) {
            this.currentScene = new scenes[index](this.app);
        }
    }
    handleResize() {
        const ratio = 720 / 1280;
        let width = window.innerWidth;
        let height = window.innerHeight;
        if (width / height >= ratio) {
            width = height * ratio;
        }
        else {
            height = width / ratio;
        }
        this.app.renderer.resize(width, height);
    }
    callFunction() {
        console.log('gotcha!');
    }
}
exports.default = Game;
